import type React from 'react';

import { GoToDepartmentLink } from '@vlabs/monokit/features/go-to-department';
import type { DepartmentId } from '@vlabs/api/artemy/model/DepartmentId';

import st from './DepartmentListItem.module.sass';

interface DepartmentListItemProps {
  departmentId: DepartmentId;
  actions?: React.ReactNode;
}

function DepartmentListItem({
  departmentId,
  actions = undefined,
}: DepartmentListItemProps): React.JSX.Element {
  return (
    <div className={st.Root}>
      <div className={st.Main}>
        <GoToDepartmentLink departmentId={departmentId} />
      </div>

      {actions}
    </div>
  );
}

export { DepartmentListItem };
